export default __webpack_public_path__ + "static/media/about.aeb5f875.png";